export default function initSearchInput() {
    let searchBtn = document.querySelector('.search-input__icon')
    if(searchBtn) {
        searchBtn.addEventListener('click', () => {
            searchBtn.parentNode.classList.toggle('active')
        })
    }
}